export const USER_DASHBOARD = "USER_DASHBOARD";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";
export const NEWORDER_COUNT = "NEWORDER_COUNT";
export const RECEIVEDORDER_COUNT = "RECEIVEDORDER_COUNT";
export const RECEIVED_RIDE_COUNT = "RECEIVED_RIDE_COUNT";
